import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import Dropdown from 'react-bootstrap/Dropdown';
import Spinner from 'react-bootstrap/Spinner';
import { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";
import qs from 'query-string';
import { categoryMap, subCategoryMap, categoryNameMap, subCategoryNameMap } from '../components/Categories.js'
import {GoogleAuth} from "google-auth-library";
import axios from "axios";



export function CompanySearchCard({ company }) {
    return (
        <Card className="company-card h-100">
            <Card.Img variant="top" src={"https://storage.googleapis.com/vv_logos/"+company.logo} className="company-card-image" />
            <Card.Body>
                <Card.Title>{company.name}</Card.Title>
                <Card.Text>{company.description}</Card.Text>
                <Card.Link href={company.website} target="_blank" rel="noopener noreferrer">
                    Website
                </Card.Link>
            </Card.Body>
            <ListGroup className="list-group-flush">
                <ListGroupItem className="company-card-list-item"><b>Impact Categories:</b> {company.impactCategories.map(impactCategory => <div className="impact-category-tag impact-tag">{categoryNameMap[impactCategory]}</div>)}</ListGroupItem>
                <ListGroupItem className="company-card-list-item"><b>Impact SubCategories:</b> {company.impactSubCategories.map(impactSubCategory => <div className="impact-subcategory-tag impact-tag">{subCategoryNameMap[impactSubCategory]}</div>)}</ListGroupItem>
                {/* <ListGroupItem className="company-card-list-item"><b>Investment Round:</b> {company.investment_round}</ListGroupItem> */}
                <ListGroupItem className="company-card-list-item"><b>Company Size: </b> {company.size}</ListGroupItem>
            </ListGroup>
            <Card.Body>
                <PostingIcons company={company}/>
            </Card.Body>
        </Card>
    );
}

export function PostingIcons({ company }) {
    return (
        <div>
            { company.crunchbase &&
            <a href={"https://crunchbase.com/organization/" + company.crunchbase} className="posting-links" target="_blank" rel="noopener noreferrer">
                <svg fill="transparent" width="36px" height="36px" viewBox="0 0 24 24">
                    <path d="M21.6,0H2.4A2.41,2.41,0,0,0,0,2.4V21.6A2.41,2.41,0,0,0,2.4,24H21.6A2.41,2.41,0,0,0,24,21.6V2.4A2.41,2.41,0,0,0,21.6,0Z"></path><path fill="currentColor" d="M9.84,13.42a2.11,2.11,0,1,1,0-1.75H11.5a3.69,3.69,0,1,0,0,1.75Z"></path><path fill="currentColor" d="M16,8.85h-.27a3.74,3.74,0,0,0-1.8.63V5.37h-1.5V15.94h1.51v-.38a3.68,3.68,0,0,0,3.39.38,3.55,3.55,0,0,0,1.06-.63A3.67,3.67,0,0,0,16,8.85Zm2.1,4a.17.17,0,0,1,0,.07,1.22,1.22,0,0,1-.06.26h0a2,2,0,0,1-.1.26l0,0a2.07,2.07,0,0,1-1,1,2,2,0,0,1-.41.15h0l-.2,0H16l-.28,0h-.07a2,2,0,0,1-.54-.17l0,0a1.86,1.86,0,0,1-.47-.32h0a2,2,0,0,1-.37-.45h0c0-.09-.1-.17-.14-.26h0a2.19,2.19,0,0,1-.17-.85,2.08,2.08,0,0,1,.2-.9h0a2.13,2.13,0,0,1,1.7-1.2l.21,0h0a2.12,2.12,0,0,1,2.12,2.12h0A2.46,2.46,0,0,1,18.1,12.8Z"></path>
                </svg>
            </a> }
            { company.linkedin &&
            <a href={"https://linkedin.com/company/" + company.linkedin} className="posting-links" target="_blank" rel="noopener noreferrer">
                <svg fill="currentColor" height="24px" viewBox="0 0 512 512" width="24px" xmlns="http://www.w3.org/2000/svg">
                    <path d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-386.892,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Zm-288.985,423.278l0,-225.717l-75.04,0l0,225.717l75.04,0Zm270.539,0l0,-129.439c0,-69.333 -37.018,-101.586 -86.381,-101.586c-39.804,0 -57.634,21.891 -67.617,37.266l0,-31.958l-75.021,0c0.995,21.181 0,225.717 0,225.717l75.02,0l0,-126.056c0,-6.748 0.486,-13.492 2.474,-18.315c5.414,-13.475 17.767,-27.434 38.494,-27.434c27.135,0 38.007,20.707 38.007,51.037l0,120.768l75.024,0Zm-307.552,-334.556c-25.674,0 -42.448,16.879 -42.448,39.002c0,21.658 16.264,39.002 41.455,39.002l0.484,0c26.165,0 42.452,-17.344 42.452,-39.002c-0.485,-22.092 -16.241,-38.954 -41.943,-39.002Z" />
                </svg>
            </a> }
            { company.angellist &&
            <a href={"https://angel.co/company/" + company.angellist} className="posting-links" target="_blank" rel="noopener noreferrer">
                <svg fill="currentColor" className="angellist-icon" height="24px" viewBox="0 0 56.7 56.7" width="24px" xmlns="http://www.w3.org/2000/svg"><g>
                    <path d="M38.8794,24.7448c2.0216,0.3824,3.4481,1.2355,4.2793,2.5609c0.8307,1.3258,1.2467,3.4149,1.2467,6.2674   c0,5.6608-1.7016,10.2939-5.1049,13.8993c-3.4032,3.605-7.7555,5.4076-13.0569,5.4076c-2.0891,0-4.1164-0.3763-6.082-1.1288   c-1.9661-0.7526-3.656-1.8027-5.0711-3.1505c-1.6174-1.4821-2.8305-3.049-3.6391-4.7c-0.8087-1.6511-1.213-3.341-1.213-5.0712   c0-1.9318,0.4156-3.4252,1.2466-4.4814c0.8307-1.0558,2.1448-1.7742,3.9424-2.1565c-0.3369-0.7863-0.5845-1.449-0.7413-1.9881   c-0.1573-0.5391-0.2359-0.9547-0.2359-1.2466c0-1.0109,0.5335-2.0438,1.6005-3.1c1.0666-1.0558,2.0723-1.5837,3.0157-1.5837   c0.4044,0,0.8307,0.073,1.2804,0.2191c0.4493,0.1465,0.9655,0.3875,1.55,0.7244c-1.7302-4.8971-2.9877-8.6765-3.7739-11.3385   c-0.7867-2.6619-1.1793-4.4983-1.1793-5.5091c0-1.3927,0.3589-2.4986,1.0782-3.319C18.7408,4.23,19.718,3.82,20.9534,3.82   c2.1112,0,4.7847,4.7174,8.0195,14.152c0.5612,1.6174,0.9884,2.8641,1.2805,3.7402c0.2471-0.6959,0.5948-1.6848,1.0445-2.9652   c3.2348-9.3448,6.0198-14.0173,8.3565-14.0173c1.1456,0,2.0606,0.3875,2.7461,1.1625c0.6851,0.775,1.0277,1.8144,1.0277,3.1169   c0,0.9888-0.3763,2.7966-1.1289,5.4249C41.5465,17.0623,40.4069,20.4992,38.8794,24.7448z M14.7535,38.4925   c0.3145,0.3823,0.7526,0.9435,1.3141,1.6848c1.4826,2.0442,2.8524,3.0663,4.1109,3.0663c0.4263,0,0.8086-0.1348,1.1456-0.4044   c0.3369-0.2695,0.5054-0.5503,0.5054-0.8424c0-0.3369-0.2247-0.8981-0.6739-1.6848c-0.4498-0.7862-1.067-1.6731-1.8533-2.6619   c-0.8985-1.1456-1.6459-1.9824-2.2407-2.5104c-0.5953-0.5274-1.0731-0.7918-1.432-0.7918c-0.7867,0-1.5112,0.4211-2.1734,1.2635   c-0.6627,0.8424-0.994,1.8364-0.994,2.982c0,0.9215,0.2302,1.9492,0.6908,3.0831c0.4601,1.1344,1.1288,2.2745,2.0049,3.4201   c1.3253,1.7747,2.9703,3.1388,4.9364,4.0935c1.9655,0.9557,4.1389,1.432,6.52,1.432c4.3804,0,8.0476-1.6341,11.0015-4.9022   c2.9535-3.2685,4.431-7.3624,4.431-12.282c0-1.5046-0.1128-2.7007-0.337-3.5885c-0.2247-0.8873-0.5953-1.5331-1.112-1.9375   c-0.9214-0.7633-2.7124-1.4489-5.3744-2.0554c-2.6619-0.6065-5.4418-0.9098-8.3396-0.9098c-0.8086,0-1.3815,0.1348-1.7184,0.4043   c-0.337,0.2696-0.5055,0.7301-0.5055,1.3815c0,1.528,0.8537,2.6339,2.5609,3.319c1.7068,0.6857,4.4698,1.0277,8.289,1.0277h1.3816   c0.3145,0,0.5672,0.118,0.7581,0.3538c0.1904,0.2359,0.3201,0.5897,0.3875,1.0615c-0.3824,0.3594-1.1682,0.7698-2.3587,1.2299   c-1.191,0.4604-2.1008,0.9153-2.7293,1.3646c-1.3479,0.9888-2.4317,2.1622-3.2516,3.5211   c-0.8204,1.3596-1.2299,2.6451-1.2299,3.8581c0,0.7414,0.1736,1.6342,0.5223,2.6788c0.3482,1.0446,0.5223,1.6904,0.5223,1.9375   v0.2359l-0.0674,0.3032c-0.9888-0.0674-1.769-0.6453-2.3418-1.7353c-0.5729-1.0895-0.8592-2.544-0.8592-4.3636v-0.3032   c-0.1802,0.1573-0.3539,0.2696-0.5223,0.337c-0.1685,0.0674-0.3539,0.1011-0.556,0.1011c-0.2022,0-0.3932-0.0169-0.5729-0.0506   c-0.1802-0.0336-0.3823-0.0842-0.6065-0.1516c0.0674,0.2476,0.118,0.4886,0.1516,0.7245c0.0337,0.2359,0.0505,0.4211,0.0505,0.556   c0,0.8312-0.3257,1.5448-0.9771,2.1396c-0.6519,0.5953-1.4269,0.8929-2.325,0.8929c-1.4151,0-2.8528-0.6908-4.313-2.0723   c-1.4606-1.3815-2.1901-2.7344-2.1901-4.0603c0-0.2471,0.0281-0.4661,0.0842-0.6571   C14.5228,38.7906,14.6188,38.6273,14.7535,38.4925z M24.8621,39.3012c0.3818,0,0.7296-0.1736,1.0445-0.5223   c0.3145-0.3482,0.4717-0.7245,0.4717-1.1288c0-0.4264-0.3089-1.4204-0.9266-2.9821c-0.6182-1.5612-1.3872-3.0943-2.3081-4.5994   c-0.6739-1.1232-1.3366-1.9711-1.988-2.544c-0.6519-0.5728-1.2692-0.8592-1.8533-0.8592c-0.4717,0-0.994,0.2982-1.5669,0.893   c-0.5728,0.5953-0.8592,1.1512-0.8592,1.6679c0,0.5391,0.2808,1.3479,0.8424,2.4261c0.5612,1.0783,1.3141,2.2239,2.2576,3.4369   c0.9884,1.3258,1.9206,2.3586,2.7967,3.1C23.649,38.9306,24.345,39.3012,24.8621,39.3012z M28.1643,23.0264l-3.6391-10.513   c-0.9435-2.6732-1.6735-4.4192-2.1901-5.2396c-0.5172-0.8199-1.0783-1.2299-1.6849-1.2299c-0.4716,0-0.8541,0.1802-1.1456,0.5391   c-0.292,0.3594-0.438,0.8424-0.438,1.4489c0,1.0334,0.3927,2.8305,1.1794,5.3913c0.7862,2.5609,1.9655,5.9192,3.538,10.0749   c0.1348-0.2471,0.3252-0.4211,0.5728-0.5223c0.2471-0.101,0.5841-0.1516,1.0109-0.1516c0.1348,0,0.4044,0.0117,0.8087,0.0337   C26.5805,22.8803,27.2428,22.937,28.1643,23.0264z M31.9718,33.2361c-0.9659-0.0449-1.8817-0.146-2.7461-0.3032   c-0.8648-0.1568-1.6904-0.3818-2.4766-0.6739c0.3589,0.7193,0.6791,1.4377,0.9604,2.1565   c0.2807,0.7193,0.5106,1.4268,0.6908,2.1228c0.5391-0.6739,1.1063-1.2856,1.7016-1.8364   C30.6966,34.1515,31.32,33.6628,31.9718,33.2361z M36.4533,24.172c1.5046-4.0884,2.6788-7.4635,3.5212-10.1255   c0.8424-2.6619,1.2635-4.2961,1.2635-4.9026c0-0.6515-0.1404-1.1568-0.4211-1.5163c-0.2813-0.359-0.6688-0.5391-1.1625-0.5391   c-0.629,0-1.2693,0.5223-1.9206,1.5668c-0.6519,1.0446-1.3703,2.7242-2.1565,5.0375l-3.3696,9.7379L36.4533,24.172z" /></g>
                </svg>
            </a> }
        </div>
    );
}

export function CompanySearch({navColor}) {
    navColor("white-nav")
    const { search } = useLocation();
    const queryParams = useMemo(() => qs.parse(search), [search]);
    let [companyEntrySize, setCompanyEntrySize] = useState(null)
    let [companies, setCompanies] = useState([]);
    const initialCategory =  (queryParams["category"] && categoryMap[queryParams["category"]]) 
        ? queryParams["category"] : "Category";
    const initialSubCategory = (queryParams["subcategory"]  && subCategoryMap[queryParams["subcategory"]])
        ? queryParams["subcategory"] : "Subcategory";
    let [category, setCategory] = useState(initialCategory);
    let [subcategory, setSubcategory] = useState(initialSubCategory);
    let [, setIsLoaded] = useState(false);
    let [, setErr] = useState(null);
        
    useEffect(() => {
        async function request(url) {
            // If development, use local credentials, else do not and rely on domain origin
            let res;
             if (process.env.NODE_ENV === 'development') {
                const credentialBody = {
                    client_email: process.env.REACT_APP_CLIENT_EMAIL,
                    private_key: process.env.REACT_APP_API_KEY
                }

                // -- Serverless GoogleAuth
                const auth1 = new GoogleAuth({credentials: credentialBody, projectId: "fleet-joy-283101"});

                let targetAudience = "https://us-central1-fleet-joy-283101.cloudfunctions.net"
                console.debug(`request ${url} with target audience ${targetAudience}`);
                const client = await auth1.getIdTokenClient(targetAudience);
                res = await client.request({url});
            } else {
                res = await axios.get(url);
            }

            return res;
          }
    
        let url = "https://us-central1-fleet-joy-283101.cloudfunctions.net/companies";
        if (category && category !== "Category") {
            url = url + "?impactCategory=" + categoryMap[category].tag;
            if (subcategory &&  subcategory !== "Subcategory") {
                url = url + "&impactSubCategory=" + subCategoryMap[subcategory];
            }
        }

        request(url)
            .then(res => {
                return res.data;
            })
            .then(response => {
                response.sort(() => Math.random() - 0.5);
                setCompanyEntrySize(response.length)
                let splitCompanies = [];
                while (response.length > 0) {
                    splitCompanies.push(response.splice(0, 4));
                }
                setCompanies(splitCompanies);
                setIsLoaded(true);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components
            error => {
                setErr(error);
                setIsLoaded(true);
            })
    }, [category, subcategory]);


    function BackFillColumns({ size }) {
        switch (4 - size) {
            case 1:
                return <Col></Col>;
            case 2:
                return <><Col></Col><Col></Col></>;
            case 3:
                return <><Col></Col><Col></Col><Col></Col></>;
            default:
        }
        return null;
    }

    return (
        <>
            <Helmet>
                <title>Virtuous Ventures - CompanySearch</title>
            </Helmet>
            <div className="whitedrop-page">
                <div className="thanks-copy">
                    <h2 className="page-title company-search-title"> Company Directory</h2>
                    <p>This is a beta feature with curated selection of mission driven startups. Companies were reviewed on their mission statements and "About Us" content for indications that these values were considered core to their operations and success.</p>
                    {/* <h4 className="feedback-header">Feedback</h4>
                    <p>I am looking for opportunities as a: <a className="opportunity-link" href="https://forms.gle/Spw2SNZ6SZ8LTZMeA" target="_blank" rel="noreferrer">Job Seeker</a>, <a className="opportunity-link" href="https://forms.gle/hDBci9RLjsk5zKkK7" target="_blank" rel="noreferrer">Founder</a>, <a className="opportunity-link" href="https://forms.gle/KXxdqppX2nzF5pZA6" target="_blank" rel="noreferrer">Investor</a>, <a className="opportunity-link" href="https://forms.gle/9nDLP3LjvUVYeJbc8" target="_blank" rel="noreferrer">Consumer</a>, <a className="opportunity-link" href="https://forms.gle/VfZesRVzvEVF1PJE6" target="_blank" rel="noreferrer">General Feedback</a>, <a className="opportunity-link" href="https://forms.gle/9oKbJaKvnBjjdk3z7" target="_blank" rel="noreferrer">Company Suggestion</a></p> */}
                    {/* <Row> */}
                    {/* <Button className="category-button opportunity-button">Job Seeker</Button>

                    <Button className="category-button opportunity-button">Founder</Button>

                    <Button className="category-button opportunity-button">Investor</Button>

                    <Button className="category-button opportunity-button">Consumer</Button>

                    <Button className="category-button opportunity-button">General Feedback</Button> */}
                    {/* </Row>             */}
                </div>


                <Container fluid>
                    <div className="dropdown-div">
                        <Dropdown className="category-dropdown-div" onSelect={(e)=>{setSubcategory("Subcategory"); setCategory(e);}}>
                            <Dropdown.Toggle id="dropdown-basic" className="subcategory-dropdown">
                                {category}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item className="dropdown-top-item" eventKey="Category">Category</Dropdown.Item>
                                <Dropdown.Item eventKey="Environment">Environment</Dropdown.Item>
                                <Dropdown.Item eventKey="Social">Social</Dropdown.Item>
                                <Dropdown.Item eventKey="Health & Wellness">Health & Wellness</Dropdown.Item>
                                <Dropdown.Item eventKey="Education">Education</Dropdown.Item>
                                <Dropdown.Item eventKey="Women">Women</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown className="category-dropdown-div" onSelect={(e)=>{setSubcategory(e)}}>
                            <Dropdown.Toggle id="dropdown-basic" className="subcategory-dropdown">
                                {subcategory}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item className="dropdown-top-item" eventKey="Subcategory">Subcategory</Dropdown.Item>
                                {categoryMap[category].subCategories.map(subCategory =>
                                    <Dropdown.Item eventKey={subCategory}>{subCategory}</Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div className="company-entry-count">Entry Count: {companyEntrySize}</div>
                    {companies.map(companychunks => <Row>
                        {companychunks.map(company => <Col xs={12} sm={12} md={3} lg={3} className="company-card-col">
                            <CompanySearchCard key={company.id} company={company} />
                        </Col>
                        )}
                        <BackFillColumns size={companychunks.length} />
                    </Row>)}
                </Container>
                { companies.length === 0 && <div className="spinners">
                    <Spinner animation="grow" size="sm" />
                    <Spinner animation="grow" />
                    <Spinner animation="grow" size="sm" />
                </div> }
            </div>
        </>
    );
}

export function getCompanies() {
    return fetch("https://us-central1-fleet-joy-283101.cloudfunctions.net/companies", {
        "method": "GET"
    })
        .then(response => response.json())
        .catch(err => {
            console.log(err);
        });
}
